/** 
 * 格式化日期
 * @method format
 * @static
 * @param {Date} d 日期对象
 * @param {string} pattern 日期格式(y年M月d天h时m分s秒)，默认为"yyyy-MM-dd"
 * @return {string}  返回format后的字符串
 * @example
 var d=new Date();
 alert(format(d," yyyy年M月d日\n yyyy-MM-dd\n MM-dd-yy\n yyyy-MM-dd hh:mm:ss"));
 */
Date.prototype.format = function (pattern) {
  pattern = pattern || 'yyyy-MM-dd'
  let y = this.getFullYear().toString(),
    o = {
      M: this.getMonth() + 1, // month
      d: this.getDate(), // day
      h: this.getHours(), // hour
      m: this.getMinutes(), // minute
      s: this.getSeconds() // second
    }
  pattern = pattern.replace(/(y+)/gi, function (a, b) {
    return y.substr(4 - Math.min(4, b.length))
  })
  for (var i in o) {
    pattern = pattern.replace(new RegExp(`(${i}+)`, 'g'), function (a, b) {
      return o[i] < 10 && b.length > 1 ? `0${o[i]}` : o[i]
    })
  }
  return pattern
}

Array.prototype.getParticularIndexInArray = function (key, value) {
  if (!key) {
    console.error('getParticularIndexInArray:(key)不能为空')
    return
  }
  if (!value) {
    console.error('getParticularIndexInArray:(value)不能为空')
    return
  }
  for (let i = 0, len = this.length; i < len; i++) {
    if (this[i][key] == value) {
      return i
    }
  }
  return -1
}
Array.prototype.getParticularObjectInArray = function (key, value) {
  for (let i = 0, len = this.length; i < len; i++) {
    if (this[i][key] == value) {
      return this[i]
    }
  }
  return null
}

export default {
  jsonToUrlParam (paramsObject) {
    return Object.keys(paramsObject)
      .map(k => `${k}=${encodeURIComponent(paramsObject[k])}`)
      .join('&')
  }
}
/**
 * simple left pad for 0-9
 */
export const pad = s => `00${s}`.slice(-2)

/**
 * get YYYY-mm-dd Date string
 */
export const getDateString = (date, sep = '-') => {
  date = date || new Date()
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate())
  ].join(sep)
}

getDateString.today = () => {
  return getDateString(new Date())
}

getDateString.yestoday = () => {
  const date = new Date()
  date.setDate(date.getDate() - 1)
  return getDateString(date)
}

getDateString.tomorrow = () => {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  return getDateString(date)
}

/**
 * datePlus('2016-02-29', 1)  // 2016-03-01
 * datePlus('2016-02-29', -1) // 2016-02-28
 */
export const datePlus = (str, days) => {
  let date
  if (typeof str === 'string') {
    date = new Date(str.replace(/-/g, '/'))
  } else if (str instanceof Date) {
    date = str
  } else {
    throw 'param invalid!'
  }

  date.setDate(date.getDate() + Number(days))
  return getDateString(date)
}

/**
 * get time: HH:mm:ss
 */
export const getTimeString = date => {
  date = date || new Date()
  return [
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds())
  ].join(':')
}

/**
 * getDatesByRange({ start: '2011-01-01', end: '2011-01-03'})
 *  ==> [ '2011-01-01', '2011-01-02', '2011-01-03' ]
 */
export const getDatesByRange = range => {
  const result = []
  let { start, end } = range
  start = new Date(start.replace(/-/g, '/'))
  end = new Date(end.replace(/-/g, '/'))

  if (start >= end) {
    throw '开始日期应当小于结束日期！'
  }

  while (start <= end) {
    result.push(getDateString(start))
    start.setDate(start.getDate() + 1)
  }

  return result
}

/**
 * dateTimeFromRange({ start: '2011-01-01', end: '2011-01-03'})
 *  ==> ["2011-01-01 00:00:00", "2011-01-02 00:00:00", "2011-01-03 00:00:00"]
 */
export const dateTimeFromRange = (range, sep = '-') => {
  return getDatesByRange(range).map(date => {
    date = new Date(date.replace(/-/g, '/'))
    return `${getDateString(date, sep)} ${getTimeString(date)}`
  })
}

// 24h in a day
export const getDateHours = (date, sep = '-') => {
  const str = getDateString()
  let end = 23
  if (str === date) {
    end = new Date().getHours()
  }
  return _.range(0, end).map(i => `${date} ${pad(i)}:00:00`)
}

// get url value by key
export const getQueryString = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 * 省份名称简化
 */
const REGION_NAME_RE = /省|市|自治区|特别行政区|回族|壮族|维吾尔|维吾尔族/g
export const provSimplify = prov => {
  if (REGION_NAME_RE.test(prov)) {
    prov.replace(REGION_NAME_RE, '')
  }
  return prov
}



// WEBPACK FOOTER //
// ./src/script/util.js